
















































































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator/lib/vue-property-decorator';
import PlantPicker from "@/view/shared-components/PlantPicker.vue";
import StatusPicker from "@/view/shared-components/StatusPicker.vue";
import WipTicket from "@/domainObjects/wip/WipTicket";
import LoadingIndicator from "@/view/shared-components/LoadingIndicator.vue";
import TicketService from "@/services/TicketService";
import {mapGetters} from "vuex";

@Component({
    components: {LoadingIndicator, StatusPicker, PlantPicker},
    computed: {
        ...mapGetters(['getGroups'])
    }
})
export default class WipSAPDetails extends Vue {
    @Prop({required: true}) wipTicket!: WipTicket;
    @Prop({required: true}) type!: string;

    private errorMessage: String = "";
    private orderLoading: boolean = false;

    @Watch('wipTicket', { immediate: true, deep: true})
    onPropertyChanged(value:WipTicket, oldvalue: WipTicket){
        this.errorMessage = "";
    }

    selectPlant(value) {
        this.wipTicket.plant = value;
    }

    selectStatus(value) {
        this.wipTicket.status = value;
    }

    editAll() {
        this.wipTicket.disableEditMaterial = !this.wipTicket.disableEditMaterial;
    }
    getOrder(){
        this.orderLoading = true;
        TicketService.getMaterialData(this.wipTicket.productionOrderNum).then((response)=>{
          if (response.data) {
                if(response.data.MaterialDataList) {
                  const materialData = response.data.MaterialDataList[0];
                  this.wipTicket.materialDesc = materialData.MaterialDescription;
                  this.wipTicket.materialNum = materialData.MaterialNumber;
                  this.wipTicket.lineItem = materialData.SalesOrderItem;
                  if (materialData.SalesOrderNo === "") {
                    this.wipTicket.salesOrderNum = "N/A"
                  } else {
                    this.wipTicket.salesOrderNum = materialData.SalesOrderNo;
                  }
                } else {
                  this.errorMessage = "prod order not found"
                }
                this.orderLoading = false;
            }
        }).catch((error)=>{
            this.errorMessage = "error";
            this.orderLoading = false;
        })
    }

    disableStatusChange(){
        // @ts-ignore
        return !(this.wipTicket.status.desc === 'Closed' && this.getGroups.includes('admin'));

    }
}
